export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const GET_INFO_USER_ONLY_ONE = "GET_INFO_USER_ONLY_ONE";